// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3441":"6f6a039d909ff3c7","4290":"af76dc5575d69422","6974":"5806d1f8c0890658","7803":"6dae8f98590d3bae"}[chunkId] + ".js";
};